import React from "react"
import { PackageResAdmin } from "../../types/apiTypes"
import FieldMessage, { Field } from "../../components/Messages/FieldMessage"

export default function ActivityListPurposeCell({ isForWeb }: PackageResAdmin) {
  return <FieldMessage id={isForWeb ? Field.IS_WEB : Field.IS_AGENCY} />
}
